import React from "react";
import "../assets/css/vasiFooterSection.css";

// replace these with your real badge assets (or keep if you already have)
//import appStoreBadge from "../assets/images/landing-page/AppStore.png";
//import playStoreBadge from "../assets/images/landing-page/GooglePlay.png";

//import Li_icon from '../assets/images/landing-page/li.png';
import instagram from '../assets/images/consumer_landing/instagram.png';
import twitter from '../assets/images/consumer_landing/twitter.png';
import linkedin from '../assets/images/consumer_landing/linkedin.png';
import facebook from '../assets/images/consumer_landing/facebook.png';
//import logo_vasi from '../assets/images/landing-page/logo_vasi.png';


export default function VasiFooterSection({
  iosUrl,
  androidUrl,
  year = new Date().getFullYear(),
  faqUrl = "/faq",
  privacyUrl = "/privacy-policy-usa",
  termsUrl = "/terms-of-service-usa",
  social = { linkedin: "https://www.linkedin.com/in/vasi-ai-301267272/", instagram: "https://www.instagram.com/vasi.ai/", x: "https://twitter.com/VaSi_Ai/", facebook: "https://www.facebook.com/profile.php?id=100093084038569" },
}) {
  return (
    <section className="vasi-footersec">
      <div className="vasi-footersec__card">
        {/* TOP: Brand block */}
        {/* <div className="vasi-footersec__top">
          <div className="vasi-footersec__brand">VaSi</div>

          <p className="vasi-footersec__desc">
            Our platform ensures that every insight is preserved and transformed
            into the guidance you need to move forward.
          </p>         
        </div> */}

        {/* BOTTOM: thin footer row */}
        <footer className="vasi-footersec__bottom">
          <div className="vasi-footersec__copy">© {year} VaSi by Learnee, Inc. All rights reserved.</div>

          <nav className="vasi-footersec__links">
            <a href={faqUrl}>FAQ</a>
            <a href={privacyUrl}>Privacy Policy</a>
            <a href={termsUrl}>Terms &amp; Conditions</a>
          </nav>

          <div className="vasi-footersec__social">
            <a target="_blank" href={social.linkedin} aria-label="LinkedIn" className="vasi-footersec__dot"><img src={linkedin} alt="LinkedIn" /></a>
            <a target="_blank" href={social.instagram} aria-label="Instagram" className="vasi-footersec__dot"><img src={instagram} alt="Instagram" /></a>
            <a target="_blank" href={social.x} aria-label="X" className="vasi-footersec__dot"><img src={twitter} alt="X" /></a>
             <a target="_blank" href={social.facebook} aria-label="Facebook" className="vasi-footersec__dot"><img src={facebook} alt="Facebook" /></a>
          </div>
        </footer>
      </div>
    </section>
  );
}
